export default __webpack_public_path__ + "static/media/ruth-shafir.040b627b.png";